import React from 'react';
import { LoginLayout } from './LoginLayout';
import { LoginWidget } from './okta-widget-customizations/LoginWidget';

export const LoginView = () => {
  return (
    <LoginLayout>
      <LoginWidget />
    </LoginLayout>
  );
};
